module.exports = __webpack_public_path__ + "img/face-purple.30fc34b4.svg";